const EXACT_KEYWORD_MATCH = 10
const INNER_KEYWORD_MATCH = 2

export function eventKeywordMap(events) {
	var eventKeyword = {}
	// Create a mapping of event keywords to the underlying event
    if (Array.isArray(events))
        events.forEach((event) => {
            if (event == null) return

            let keyword = event.keyword || []
            keyword = keyword.filter((k) => (k != null)).map((k) => k.toLowerCase())
            keyword.forEach((kw) => {
				kw = kw.trim()
                if (! eventKeyword[kw])
                    eventKeyword[kw] = {}
                eventKeyword[kw][event.id] = (eventKeyword[kw][event.id] || 0) + EXACT_KEYWORD_MATCH
            })
        })
    return eventKeyword
}

export function eventProfileMap(events, profiles) {
	var eventProfile = {}

	profiles.forEach((profile) => {
		if (Array.isArray(profile.event))
			profile.event.forEach((event) => {
				if (typeof event === 'string')
					eventProfile[event] = profile.id
				else if (event != null && typeof event === 'object')
					eventProfile[event.id] = profile.id
			})
	})

	return eventProfile
}
